import * as type from '../types/news';
import actionCreatorFactory from 'typescript-fsa';
var actionCreator = actionCreatorFactory();
export var requestNewsList = actionCreator(type.REQUEST_LIST);
export var successNewsList = actionCreator(type.SUCCESS_LIST);
export var failureNewsList = actionCreator(type.FAILURE_LIST);
export var requestNewsDetail = actionCreator(type.REQUEST_DETAIL);
export var successNewsDetail = actionCreator(type.SUCCESS_DETAIL);
export var failureNewsDetail = actionCreator(type.FAILURE_DETAIL);